import React, { useState } from "react"
import './index.css'

import img1 from '../../resources/arsinoe_vr_teaser.jpg';
import img2 from '../../resources/BadScenarioOverview.png';
import img3 from '../../resources/Scanning.png';
import img4 from '../../resources/SpaceCraftTalk.png';
import img5 from '../../resources/Miniature.png';
import img6 from '../../resources/GoodScenarioOverview.png';

export default function Carousel()
{
        // Array of images or carousel items
        const items = [
            img1,
            img2,
            img3,
            img4,
            img5,
            img6
        ];
    
        // State to track the current slide
        const [currentIndex, setCurrentIndex] = useState(0);
        const [inTransition, setInTransition] = useState(false);  // To track if the transition is happening
    
        // Function to go to the previous slide
        const prevSlide = () => {
            if (inTransition) return;  // Prevent changing slides while transition is ongoing
            setInTransition(true);
            // Delay the slide change after the transition
            setTimeout(() => {
                setCurrentIndex(currentIndex === 0 ? items.length - 1 : currentIndex - 1);
            }, 500);  // Wait for the transition duration (500ms) before changing image
        };
    
        // Function to go to the next slide
        const nextSlide = () => {
            if (inTransition) return;  // Prevent changing slides while transition is ongoing
            setInTransition(true);
            // Delay the slide change after the transition
            setTimeout(() => {
                setCurrentIndex(currentIndex === items.length - 1 ? 0 : currentIndex + 1);
            }, 500);  // Wait for the transition duration (500ms) before changing image
        };

        // Reset transition state after the transition ends
        const handleTransitionEnd = () => {
            setInTransition(false);
        };
    
        return (
            <div className="carousel relative">
                <div className="carousel-container relative">
                    {/* Carousel Image with transition */}
                    <img 
                        src={items[currentIndex]} 
                        alt={`Slide ${currentIndex + 1}`} 
                        className={`carousel-image w-full h-screen object-cover ${inTransition ? "transitioning" : ""}`} 
                        onTransitionEnd={handleTransitionEnd}  // Reset transition state
                    /> 
                
                    {/* Dark Overlay */}
                    <div className="absolute inset-0 bg-black bg-opacity-50"></div>

                    {/* Centered Text */}
                    <div className="absolute inset-0 flex items-center justify-center">
                        <h1 className="text-white text-4xl md:text-6xl font-bold text-center px-4">
                            Welcome to Arsinoe VR<br />
                            <span className="text-lg md:text-2xl font-medium">
                            Inspiring a sustainable future
                            </span>
                        </h1>
                    </div>
                </div>

                {/* Navigation Buttons */}
                <button className="carousel-button prev-button" onClick={prevSlide}>&lt;</button>
                <button className="carousel-button next-button" onClick={nextSlide}>&gt;</button>
                
                {/* Dots indicating the current image */}
                <div className="dots-container">
                    {items.map((_, index) => (
                        <div 
                            key={index} 
                            className={`dot ${index === currentIndex ? "active" : ""}`} 
                            onClick={() => setCurrentIndex(index)}  // Change to selected slide when dot is clicked
                        ></div>
                    ))}
                </div>

            </div>
        );
}